import { render, staticRenderFns } from "./BtnAtualizarAditivo.vue?vue&type=template&id=4422cc35&"
import script from "./BtnAtualizarAditivo.vue?vue&type=script&lang=js&"
export * from "./BtnAtualizarAditivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports